"use client";

import { useState } from "react";
import { Checkbox } from "@nextui-org/react";
import Header from "@/components/client/Header";
import NoData from "@/components/client/NoData";

const MatchDetail = ({ home: homeTeam, away: awayTeam, goalStats }) => {
  const [isSameChecked, setIsSameChecked] = useState(false);

  const data = goalStats?.haftTimeFullTimeResult || {};
  const { home, away } = isSameChecked ? data?.normal : data?.similarity;

  const labels = [
    "T/T",
    "T/H",
    "T/B",
    "H/T",
    "H/H",
    "H/B",
    "B/T",
    "B/H",
    "B/B",
  ];

  const homeArray = home.split(",").map((item) => (item == "-" ? 0 : item));
  const awayArray = away.split(",").map((item) => (item == "-" ? 0 : item));

  const renderMatchDetail = () => {
    if (home === "-" || away === "-") {
      return <NoData />;
    }

    return labels.map((label, index) => (
      <div className={"flex flex-col gap-2 "}>
        <div className={"flex flex-row gap-2 [&>*]:flex-1 "}>
          <div
            className={
              "w-[30px] h-[88px] flex flex-col justify-end bg-[#ebeff5] rounded-tl rounded-tr text-button-blue-bet dark:bg-dark-slate"
            }
          >
            <div>{homeArray[index] || ""}</div>
            <div
              className={"bg-button-blue-bet"}
              style={{ height: `${homeArray[index]}%` }}
            ></div>
          </div>
          <div
            className={
              "w-[30px] h-[88px] flex flex-col justify-end bg-[#f6f5ef] rounded-tl rounded-tr text-golden-yellow dark:bg-dark-slate"
            }
          >
            <div>{awayArray[index] || ""}</div>
            <div
              className={"bg-golden-yellow"}
              style={{ height: `${awayArray[index]}%` }}
            ></div>
          </div>
        </div>
        <div className={"w-full rounded font-semi-bold text-center dark:text-white"}>T/T</div>
      </div>
    ));
  };

  return (
    <div className={"px-0 lg:px-8 py-4"}>
      <Header home={homeTeam} away={awayTeam} title="Chi tiết về HT/FT" />
      <div className={"px-0 lg:px-[34px]"}>
        <div className={"flex flex-row mt-4 [&>*]:flex-1 "}>
          <div className={"flex flex-row justify-between mb-4 "}>
            <div
              className={
                "flex flex-col lg:flex-row justify-start gap-1 lg:gap-4 [&>*]:flex [&>*]:flex-row  [&>*]:justify-start lg:[&>*]:justify-center [&>*]:items-center [&>*]:gap-2 "
              }
            >
              <div>
                <div className={"w-3.5 h-3.5 bg-button-blue-bet"}></div>
                <div className={""}>Chủ</div>
              </div>
              <div>
                <div className={"w-3.5 h-3.5 bg-golden-yellow"}></div>
                <div className={""}>Khách</div>
              </div>
            </div>

            <div
              className={
                "flex flex-row justify-end gap-4 [&>*]:flex [&>*]:flex-row-reverse [&>*]:@md:flex-row [&>*]:justify-center [&>*]:items-center w-[140px] @md:w-full"
              }
            >
              <Checkbox
                color={"default"}
                size={"sm"}
                className={"max-lg:!flex-row-reverse max-lg:!text-right"}
                checked={isSameChecked}
                onChange={() => setIsSameChecked(!isSameChecked)}
              >
                Chủ khách tương đồng
              </Checkbox>
            </div>
          </div>
        </div>

        <div
          className={
            "w-full text-xs  flex flex-row gap-3 @md:gap-4 [&>*]:flex-1 [&>*]:text-center [&>*:first-child]:pl-[0] [&>*:last-child]:pr-[0] divide-league-dark-detail text-blur-gray overflow-auto p-2"
          }
        >
          {renderMatchDetail()}
        </div>
      </div>
    </div>
  );
};

export default MatchDetail;
